































































































import { Component } from "vue-property-decorator";

import { DialogSection, DialogForm, FormText } from "sitewhere-ide-components";
import { VFlex } from "vuetify/lib";

import { IEventHubConfiguration } from "sitewhere-configuration-model";
import { required } from "vuelidate/lib/validators";

@Component({
  components: { VFlex, DialogForm, FormText },
  validations: {
    consumerGroupName: {
      required
    },
    namespaceName: {
      required
    },
    eventHubName: {
      required
    },
    sasKeyName: {
      required
    },
    sasKey: {
      required
    },
    storageConnectionString: {
      required
    },
    storageContainerName: {
      required
    },
    hostNamePrefix: {
      required
    }
  }
})
export default class EventHubFields extends DialogSection {
  consumerGroupName = "";
  namespaceName = "";
  eventHubName = "";
  sasKeyName = "";
  sasKey = "";
  storageConnectionString = "";
  storageContainerName = "";
  hostNamePrefix = "";

  /** Reset section content */
  reset(): void {
    this.consumerGroupName = "";
    this.namespaceName = "";
    this.eventHubName = "";
    this.sasKeyName = "";
    this.sasKey = "";
    this.storageConnectionString = "";
    this.storageContainerName = "";
    this.hostNamePrefix = "";
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  load(input: IEventHubConfiguration): void {
    this.consumerGroupName = input.consumerGroupName || "";
    this.namespaceName = input.namespaceName || "";
    this.eventHubName = input.eventHubName || "";
    this.sasKeyName = input.sasKeyName || "";
    this.sasKey = input.sasKey || "";
    this.storageConnectionString = input.storageConnectionString || "";
    this.storageContainerName = input.storageContainerName || "";
    this.hostNamePrefix = input.hostNamePrefix || "";
  }

  /** Save form data to an object */
  save(): {} {
    return {
      consumerGroupName: this.consumerGroupName,
      namespaceName: this.namespaceName,
      eventHubName: this.eventHubName,
      sasKeyName: this.sasKeyName,
      sasKey: this.sasKey,
      storageConnectionString: this.storageConnectionString,
      storageContainerName: this.storageContainerName,
      hostNamePrefix: this.hostNamePrefix
    };
  }
}
